export enum APLocalStorageKeys {
    USER_DATA = "user-data"
}
